/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { H7 } from 'foundations-components/transitional/components/H7';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { selectIsFetchingThingsPeopleCover } from '../data/loading/slice';
import { selectThingsPeopleCover } from '../data/thingsPeopleCover/slice';
import { fetchThingsPeopleCover } from '../data/thingsPeopleCover/thunks';
import { useDispatch, useSelector } from '../store';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThingsPeopleCover = ({
  phrase
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchThingsPeopleCover({
      phrase
    }));
  }, [dispatch, phrase]);
  const isFetchingThingsPeopleCover = useSelector(selectIsFetchingThingsPeopleCover);
  const thingsPeopleCover = useSelector(selectThingsPeopleCover);
  if (isFetchingThingsPeopleCover) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 100
    });
  }
  if (thingsPeopleCover.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "topic-editor-things-people-cover",
    marginBlockEnd: "400",
    as: "section",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.attachedState.thingsPeopleCover.header"
      })
    }), /*#__PURE__*/_jsx(ExpandableText, {
      buttonAlign: "left",
      hideButtonCaret: true,
      expandButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.attachedState.thingsPeopleCover.expandButton"
      }),
      collapseButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.attachedState.thingsPeopleCover.collapseButton"
      }),
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: thingsPeopleCover.map(keyword => /*#__PURE__*/_jsx("span", {
          children: keyword
        }, keyword))
      })
    })]
  });
};